<template>
    <ButtonGroup v-if="hasPages" class="my-8">
        <Button v-for="page in pages" :key="page.number" as-child v-bind="pageButtonProperties(page)">
            <NuxtLink :to="page.path">{{ page.number }}</NuxtLink>
        </Button>
    </ButtonGroup>
</template>
<script setup lang="ts">
import type { ButtonVariants } from "~/components/ui";

const { pages = [] } = defineProps<{ pages?: CMSPostPage[] }>();

const route = useRoute();

const hasPages = computed(() => pages.length > 1);

function pageButtonProperties(page: CMSPostPage): ButtonVariants {
    return route.path === page.path ? { fill: "solid" } : {};
}
</script>
